export default function createReduceResults({promiseThunk, getParams, reduceOriginal}) {
    return function reduceResults(results, action, ...args) {
        if (!action.type in promiseThunk.types) {
            return results;
        }

        let otherArgs = args;


        switch (action.type) {
            case promiseThunk.types.PENDING:
                let loadingParams = getParams(results, ...args);
                return {
                    ...reduceOriginal(results, action),
                    loadingParams: loadingParams
                };
            case promiseThunk.types.SUCCESS:
                return loadingParams = {
                    ...reduceOriginal(results, action),
                    loadedParams: results.loadingParams,
                    loadingParams: null
                };
            case promiseThunk.types.CANCELED:
                return reduceOriginal(results, action);
        }

        return {
            ...reduceOriginal(results, action),
            loadingParams: null
        };
    }
};